// src/components/base/Button/Button.tsx
import { ComponentChildren } from 'preact';
import type { ComponentProps } from 'preact';
import styles from './Button.module.css';

export interface ButtonProps extends ComponentProps<'button'> {
  variant?: 'primary' | 'secondary' | 'link';
  loading?: boolean;
  fullWidth?: boolean;
  children?: ComponentChildren;
}

export function Button({
  variant = 'primary',
  loading = false,
  disabled = false,
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const classNames = [
    styles.button,
    styles[variant],
    loading ? styles.loading : '',
    fullWidth ? styles.fullWidth : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      class={classNames}
      disabled={disabled || loading}
      aria-busy={loading}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </button>
  );
}
